import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=13d6bbce&"
import script from "@/views/Contractors/Feedback/Feedback.ts?vue&type=script&lang=ts&"
export * from "@/views/Contractors/Feedback/Feedback.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports